<template>
    <header id="header-main" class="w-full shadow">
        <div class="flex flex-wrap dark:bg-primary-dark py-2">
            <div class="hidden md:flex md:w-1/6 justify-center">
                <logo-main />
            </div>
            <div class="w-full md:w-4/6 justify-center flex items-center">
                <h1 class="text-3xl mx-4 font-semibold">
                    <span class="text-primary-emphasis dark:text-white">
                        soft
                    </span>
                    <span
                        class="text-primary-secondary dark:text-primary-primary"
                    >
                        · json ·
                    </span>
                    <span class="text-primary-emphasis dark:text-white">
                        tool
                    </span>
                </h1>
            </div>
            <div class="w-full md:w-1/6 flex justify-center items-center">
                <language-selector />
            </div>
        </div>
    </header>
</template>

<script>
import LogoMain from "@/components/layout/LogoMain.vue";
import LanguageSelector from "@/components/utils/LanguageSelector.vue";

export default {
    components: {
        LogoMain,
        LanguageSelector
    },
    props: {}
};
</script>
